export const builderRoute = "/apartment/builder"
export const builderDocumentsRoute = "/builder/getDocBuilder"
